import { Component, OnDestroy } from '@angular/core';
import { NavController, NavParams, Platform, LoadingController, 
  ModalController 
} from 'ionic-angular';
import { Subscription }  from 'rxjs/Subscription';
import { DataProvider } from '../../providers/data/data';

@Component({
  selector: 'page-medloc-results',
  templateUrl: 'medloc-results.html',
})
export class MedlocResultsPage implements OnDestroy {
  dataList: any[] = [];
  datax: any[] = [];
  dataResult: any[] = [];
  townResult: any[] = [];
  sku: string;
  skuDesc: string;
  sjdBranch: string;
  itemcode: any;
  province: any;
  town: any;
  towncode: any;
  provcode: any;
  startup: any;
  user: any;
  branchcode: any;

  s_town: Subscription;
  s_province: Subscription;
  _datatown: any[] = [];
  _dataprov: any[] = [];
  itemDetlSubs: Subscription;
  noRec: string;

  loadingx = this.loadingCtrl.create({
    content:'Loading Data, please wait...',
    enableBackdropDismiss: true
  });

  constructor(public navCtrl: NavController, public navParams: NavParams
  	, private platform: Platform
    , private dataProv: DataProvider
    , private loadingCtrl: LoadingController
    , private modalCtrl: ModalController
  	) {
  }

  ionViewDidLoad() {

    this.sku  = this.navParams.get('skuCode');
    this.skuDesc = this.navParams.get('skuDesc');
    this.town =  this.navParams.get('towncode');
    this.province = this.navParams.get('provcode');
    this.itemcode = this.navParams.get('skuCode');
    this.user = this.navParams.get('user');
    this.branchcode = this.navParams.get('branch');
    this.sjdBranch = 'nearby';
  
    this.checkprovince();

    this.saveSearch();

  }

  saveSearch(){
      this.dataProv.saveSearchMed(this.itemcode, this.user, this.branchcode)
      .subscribe((rs: any[]) => {
      },
      error => {
      },
      function() {  
      });
  }

  initData() {

    let loadingmessage = this.loadingCtrl.create({
      content:'Loading Data, please wait...',
      enableBackdropDismiss: true
    });
    loadingmessage.present();
    this.datax = [];
    this.dataList = [];
    let itm = this.itemcode;
    let tcode = this.town;
    let pcode = this.province;
    let p_user = this.user;
    let p_branchcode = this.branchcode;
    if(this.startup == 'province') this.town = "ALL"; 
    
    this.itemDetlSubs = this.dataProv.getMedLoc(itm, tcode, pcode)
      .subscribe((rs: any[]) => {
        if(rs.length > 0) {
          console.log("DS "+rs.length);
          this.dataList = rs;
          this.datax = rs;
          this.dataResult = rs;
          console.log(this.dataList);
          if(this.dataList.length ==  0)this.noRec = 'No records found...';    
          if(this.startup == 'onload') this.filterTown();  
        } else {
          this.dataResult=[];
          this.noRec = 'No records found...';
        }
      },
      error => {
        alert('Slow Connection: Cannot load data due to slow connection');
        loadingmessage.dismiss();
      },
      function() {  
        loadingmessage.dismiss();
      });
  }

  filterTown(){
    let tcode = this.town;
    let town_code: any [] = [];
    console.log(tcode);
    if (tcode == "ALL"){
      town_code = this.dataList;
    }
    else{
      for (var i=0; i < this.dataList.length; i++){
        if (this.dataList[i].s_towncode == tcode){
          town_code.push(
            { 
              n_qtyohand: this.dataList[i].n_qtyohand,
              s_brnccode: this.dataList[i].s_brnccode,
              s_brncaddr: this.dataList[i].s_brncaddr,
              s_brncname: this.dataList[i].s_brncname,
              s_contnmbr: this.dataList[i].s_contnmbr,
              s_itemdesc: this.dataList[i].s_itemdesc,
              s_itemnmbr: this.dataList[i].s_itemnmbr,
              s_latilong: this.dataList[i].s_latilong,
              s_mobileno: this.dataList[i].s_mobileno,
              s_provcode: this.dataList[i].s_provcode,
              s_schedule: this.dataList[i].s_schedule,
              s_towncode: this.dataList[i].s_towncode,
              updated_date: this.dataList[i].updated_date
            }
          );
        }
        else{
        }
      }
    }
    this.dataResult=[];
    this.dataResult = town_code;  
  }

  ionViewDidEnter() {
  }

  ionViewWillLeave() {
  }

  ngOnDestroy() {
    if(this.itemDetlSubs) {
      this.itemDetlSubs.unsubscribe();
    }
  }

  checktown(){
    this.s_town = this.dataProv.getTown()
    .subscribe((rs: any[]) => {
      this._datatown = rs;
      this.displayTown('onload');
      
    }, error => {
      console.log('Network Connection Error: Failed to load Town.');
    }, function() {
    });
  }

  displayTown(stat){
      this.startup = stat;
      let p = this.province;
      let townfilter: any [] = [];
      for (var i=0; i < this._datatown.length; i++){
        if (this._datatown[i].s_provcode == p){     
          townfilter.push(
            { 
              id:this._datatown[i].id,
              s_provcode:this._datatown[i].s_provcode,
              s_towncode:this._datatown[i].s_towncode,
              s_townname:this._datatown[i].s_townname
            }
          );
        }
        else{
        }
      }
      
      this.dataResult = [];
      this.townResult=[];
      this.townResult = townfilter;
      this.loadingx.dismiss();
      this.initData();  
  }

  checkprovince(){
    this.loadingx.present();
    this._dataprov = [];
    this.s_province = this.dataProv.getProvince()
    .subscribe((prs: any[]) => {
      this._dataprov = prs;
      this.checktown();
    }, error => {
      console.log('Network Connection Error: Failed to load Province');
    }, function() {
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/medloc-results/medloc-results.ts